export default class ScriptHelper {

    static async load_script(url) {
        if (ScriptHelper.promises[url]) {
            return ScriptHelper.promises[url];
        }

        let $existing = $("script[src='" + url + "']");
        if ($existing.length > 0) return;


        let promise = new Promise((resolve, reject) => {
            let elem = document.createElement("script");
            elem.type = "text/javascript";
            elem.async = true;
            elem.defer = true;

            elem.onload = resolve;
            elem.onerror = reject;

            elem.src = url;

            document.head.appendChild(elem);
        });

        ScriptHelper.promises[url] = promise;

        return promise;
    }
}

ScriptHelper.promises = {};